// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/link_aliases/get_triggerable_links" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdLinkAliasesGetTriggerableLinks } from "./constants";
import type { EngagementAppGroupIdLinkAliasesGetTriggerableLinksResult } from "./types";

export const getEngagementAppGroupIdLinkAliasesGetTriggerableLinks = reactQueryFetcherAdapter(
  engagementAppGroupIdLinkAliasesGetTriggerableLinks,
  (
    signal: AbortSignal,
    appGroupId: string,
    campaignId?: string,
    workflowStepIds?: string[],
    workflowId?: string
  ): Promise<EngagementAppGroupIdLinkAliasesGetTriggerableLinksResult> => {
    return fetch(
      `/engagement/${appGroupId}/link_aliases/get_triggerable_links`,
      "GET",
      { mc_id: campaignId, ws_ids: workflowStepIds, wf_id: workflowId },
      { signal }
    );
  }
);
